import { Attribute, Directive, HostBinding } from '@angular/core';
import { NO_BROWSER_AUTOFILL } from '../../maps/no-browser-autofill';

@Directive({
  selector: '[appPreventAutoComplete]',
})
export class PreventAutoCompleteDirective {
  @HostBinding('attr.autocomplete') auto;
  constructor(@Attribute('autocomplete') autocomplete: string) {
    this.auto = autocomplete || NO_BROWSER_AUTOFILL;
  }
}
